import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BookOpen, X } from 'lucide-react';
import ManualBook from './ManualBook';
import { getChapterForRoute } from './manualRouteMap';
import { useTranslation } from '../../i18n';

/**
 * Floating button (top-right, below the day-controls) that opens the
 * pedagogical manual. Visible only when the player has entered the game
 * (Layout renders it only inside GameRoutes).
 */
export default function ManualButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  // Chapter to open on : computed at click time so it stays fresh as the
  // player navigates between routes without having to remount.
  const initialChapter = getChapterForRoute(location.pathname);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed top-4 right-4 z-40 w-12 h-12 rounded-full bg-gradient-to-br from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center justify-center group"
        aria-label={t('manual_open_aria')}
        data-testid="manual-open-btn"
      >
        <BookOpen className="w-5 h-5" />
        <span className="absolute right-full mr-3 px-2 py-1 rounded bg-ink-800 text-xs text-slate-200 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          {t('manual_label')}
        </span>
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[110] bg-black/85 backdrop-blur-md flex items-center justify-center p-4"
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
          data-testid="manual-overlay"
        >
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
            data-testid="manual-close-btn"
            aria-label={t('manual_close_aria')}
          >
            <X className="w-5 h-5" />
          </button>
          <ManualBook onClose={() => setOpen(false)} initialChapter={initialChapter} />
        </div>
      )}
    </>
  );
}
